import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"archive\"><g id=\"Group 552\"><path id=\"Vector\" d=\"M20.1 3.89999H3.9C3.40294 3.89999 3 4.30294 3 4.79999V7.49999C3 7.99705 3.40294 8.39999 3.9 8.39999H20.1C20.5971 8.39999 21 7.99705 21 7.49999V4.79999C21 4.30294 20.5971 3.89999 20.1 3.89999Z\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_2\" d=\"M4.80005 8.39999V18.3C4.80005 18.7774 4.98969 19.2352 5.32726 19.5728C5.66482 19.9104 6.12266 20.1 6.60005 20.1H17.4C17.8774 20.1 18.3353 19.9104 18.6728 19.5728C19.0104 19.2352 19.2 18.7774 19.2 18.3V8.39999\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path id=\"Vector_3\" d=\"M10.2 12H13.8\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }